const UNITS = [
  'cero',
  'uno',
  'dos',
  'tres',
  'cuatro',
  'cinco',
  'seis',
  'siete',
  'ocho',
  'nueve',
];

const TEENS = [
  'diez',
  'once',
  'doce',
  'trece',
  'catorce',
  'quince',
  'dieciséis',
  'diecisiete',
  'dieciocho',
  'diecinueve',
];

const TENS = [
  '',
  'diez',
  'veinte',
  'treinta',
  'cuarenta',
  'cincuenta',
  'sesenta',
  'setenta',
  'ochenta',
  'noventa',
];

const VEINTE_COMBINATIONS = {
  21: 'veintiuno',
  22: 'veintidós',
  23: 'veintitrés',
  24: 'veinticuatro',
  25: 'veinticinco',
  26: 'veintiséis',
  27: 'veintisiete',
  28: 'veintiocho',
  29: 'veintinueve',
};

const HUNDREDS = [
  '',
  'ciento',
  'doscientos',
  'trescientos',
  'cuatrocientos',
  'quinientos',
  'seiscientos',
  'setecientos',
  'ochocientos',
  'novecientos',
];

const normalizeSpaces = (text) => text.replace(/\s+/g, ' ').trim();

const apocopeNumberWords = (text) =>
  text
    .replace(/uno$/, 'un')
    .replace(/veintiuno$/, 'veintiún');

const convertTens = (number) => {
  if (number < 10) {
    return UNITS[number];
  }
  if (number < 20) {
    return TEENS[number - 10];
  }
  if (number >= 21 && number <= 29) {
    return VEINTE_COMBINATIONS[number];
  }

  const tens = Math.floor(number / 10);
  const units = number % 10;
  if (units === 0) {
    return TENS[tens];
  }
  return `${TENS[tens]} y ${UNITS[units]}`;
};

const convertHundreds = (number) => {
  if (number === 0) {
    return '';
  }
  if (number === 100) {
    return 'cien';
  }

  const hundreds = Math.floor(number / 100);
  const remainder = number % 100;

  const hundredsText = hundreds > 0 ? `${HUNDREDS[hundreds]} ` : '';
  const tensText = remainder > 0 ? convertTens(remainder) : '';

  return normalizeSpaces(`${hundredsText}${tensText}`);
};

const convertNumber = (number) => {
  if (number < 1000) {
    return convertHundreds(number);
  }

  if (number < 1000000) {
    const thousands = Math.floor(number / 1000);
    const remainder = number % 1000;
    const thousandsText =
      thousands === 1 ? 'mil' : `${apocopeNumberWords(convertNumber(thousands))} mil`;
    const remainderText = remainder ? convertHundreds(remainder) : '';
    return normalizeSpaces(`${thousandsText} ${remainderText}`);
  }

  if (number < 1000000000) {
    const millions = Math.floor(number / 1000000);
    const remainder = number % 1000000;
    const millionsText =
      millions === 1
        ? 'un millón'
        : `${apocopeNumberWords(convertNumber(millions))} millones`;
    const remainderText = remainder ? convertNumber(remainder) : '';
    return normalizeSpaces(`${millionsText} ${remainderText}`);
  }

  if (number < 1000000000000) {
    const billions = Math.floor(number / 1000000000);
    const remainder = number % 1000000000;
    const billionsText =
      billions === 1
        ? 'mil millones'
        : `${apocopeNumberWords(convertNumber(billions))} mil millones`;
    const remainderText = remainder ? convertNumber(remainder) : '';
    return normalizeSpaces(`${billionsText} ${remainderText}`);
  }

  const trillions = Math.floor(number / 1000000000000);
  const remainder = number % 1000000000000;
  const trillionsText =
    trillions === 1
      ? 'un billón'
      : `${apocopeNumberWords(convertNumber(trillions))} billones`;
  const remainderText = remainder ? convertNumber(remainder) : '';
  return normalizeSpaces(`${trillionsText} ${remainderText}`);
};

export const numberToSpanishWords = (value) => {
  const numeric = Number.isFinite(Number(value)) ? Math.floor(Math.abs(Number(value))) : 0;
  if (numeric === 0) {
    return 'cero';
  }
  return convertNumber(numeric);
};
